import {useCallback, useEffect} from "react";

enum Key {
    Escape = 'Escape',
}

export const useKeydownHandler = (onKeyDownHandler: () => void, key: Key = Key.Escape) => {

    useEffect(() => {
        document.addEventListener('keydown', handleKeydown);
        return () => {
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [key, onKeyDownHandler]);

    const handleKeydown = useCallback((e: KeyboardEvent) => {
        if (e.code === key) {
            e.preventDefault();
            e.stopPropagation();
            onKeyDownHandler();
        }
    }, [key, onKeyDownHandler])
}